<template>
    <div class="main-content scroll" v-if="show">
<!--        <div class="btn_group">-->
<!--            <router-link :to="'/funnel/'+ $route.params.id + '/settings'" class="btn flat icon">-->
<!--                <inline-svg :src="require('@/assets/img/settings_btn.svg')"/>-->
<!--            </router-link>-->
<!--        </div>-->
        <div class="image_main">
            <inline-svg :src="require('@/assets/img/start_up 1.svg')"/>
        </div>

        <h2 class="title_step">1st Step</h2>
        <p class="parag">Let’s create your funnel! Watch the tutorial below to learn how to easily do it:</p>

        <div class="video_banner">
            <div class="wrap_video">
                <div class="hytPlayerWrapOuter">
                    <div class="hytPlayerWrap">
                      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/6fEY2DDrT6Y?controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>

        <div class="wrap_settings_box">
            <div class="left_box">
                <div class="icon">
                    <inline-svg :src="require('@/assets/img/settings_2.svg')"/>
                </div>
            </div>

            <div class="right_box">
                <p class="parag">Copy the tracking text below, and past it into your </p>
                <ul class="bread_crumbs">
                    <li><a>Clickfunnels’ Funnel</a></li>
                    <li class="step_crumbs">></li>
                    <li><a>Settings</a></li>
                    <li class="step_crumbs">></li>
                    <li><a>Head tracking code</a>.</li>
                </ul>
            </div>
        </div>

        <div class="script">
            <textarea class="code_box_textarea" readonly>
                <script async
                    type="text/javascript"
                    src="https://app.funnelish.com/xapp.js"
                    data-vip-email="{{getUserInfo.member.email}}"
                    data-api-key="{{getUserInfo.api_key}}">
                </script>
                <link rel="stylesheet" type="text/css" href="https://funnelish.com/paypal-plugin-2.0.css">
            </textarea>
            <a @click="copyToClipboard('.code_box_textarea')" class="icon">
                <inline-svg :src="require('@/assets/img/copy_link_1.svg')"/>
            </a>
        </div>

        <p class="parag">
            You can find your funnel tracking code at any time, under your
            <router-link :to="'/funnel/'+ $route.params.id + '/settings'">Funnel settings</router-link>.
        </p>
        <h2 class="title_step">2nd Step</h2>
        <p class="parag">Now start adding your steps to the funnel</p>
        <a @click="showAddNewStepPopup" class="btn">Add new step</a>
    </div>
</template>

<script>
import API from "@/api"
import { mapGetters } from "vuex"

export default {
    name: 'FunnelOnboarding',
    mixins: [API],
    data() {
        return {
            show: false
        }
    },
    computed: {
        ...mapGetters(["getStepDataStore"]),
        getUserInfo() {
            return this.$store.state.userInfo
        }
    },
    methods: {
        redirectToStep(steps) {
          let {id} = this.$route.params;
	        let stepId = steps[0].id;
					let lowestIndex = steps[0].order_index || 100000000;

	        steps.forEach((x,i)=> {
	        	if (x.order_index < lowestIndex) {
			        stepId = x.id;
			        lowestIndex = x.order_index;
		        }
          });
          this.$router.push({ path: `/funnel/${id}/steps/${stepId}` });
        },
        checkStepData(steps) {
            if(steps.length) this.redirectToStep(steps);
            else this.show = true;
        },
        copyToClipboard(queryElem) {
            let elemToCopy = document.querySelector(queryElem);
            elemToCopy.setAttribute('type', 'text');
            elemToCopy.select();

            try { var successful = document.execCommand('copy') }
            catch (err) { alert('Oops, unable to copy') }

            elemToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        showAddNewStepPopup() {
            this.$store.commit("showAddNewStepPopup");
        },
        async init() {
            if(this.getStepDataStore) this.checkStepData(this.getStepDataStore)
            else this.show = true;
        }
    },
    created() {
        this.init()
    }
}
</script>
<style lang="scss">
.wrap_video {
  border: 8px solid #e3e6f1;
  border-radius: 10px;
}
</style>
